module.exports = __webpack_public_path__ + "img/logo-arcoship-BLUE.d4b24777.png";